import React from 'react'
import { Services } from '../component/Services'
import { Footer } from '../layout/Footer'
import { Navigationbar } from '../layout/Navigationbar'

export const Servicespage = () => {
  return (
    <div>
        <Navigationbar/>
        <Services/>
        <Footer/>
        
    </div>
  )
}
